import { render, staticRenderFns } from "./JsObjectView.vue?vue&type=template&id=4944d885"
import script from "./JsObjectView.vue?vue&type=script&lang=js"
export * from "./JsObjectView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports